const inputCls = "_086i1bkjksu";

export { inputCls };
import "./TableCellInputReadonly.style.linaria.module.css";
//# sourceMappingURL=TableCellInputReadonly.style.js.map
